import update from 'react-addons-update';
import { i18n } from 'core/i18n';
import {
	MANAGE_SEARCH_SUCCESS,
	MANAGE_GET_AGENT_SUCCESS,
	MANAGE_PUT_AGENT_SUCCESS,
	MANAGE_UPDATE_AGENT_INFO,
	MANAGE_CLEAR_AGENT_INFO,
	MANAGE_CLEAR_AGENT_LIST,
	MANAGE_POST_ERROR,
	MANAGE_CLEAR_ERROR,
} from './action.js';

const initState = {
	searchResult: [],
	editAgentId: '',
	agentInfo: null,
	addressInfo: null,
	errors: null,
	showSuccessDialog: false
};

export default function manageReducer(state = initState, action) {
	switch (action.type) {
		case MANAGE_SEARCH_SUCCESS:
			//帶入編輯用id欄位
			let result = JSON.parse(JSON.stringify(action.data.data));

			if (result && result.length > 0) {
				result.forEach(item => {
					item['edit'] = item.id;
				});
			} else { 
				result.push({ agentName: i18n('no_agent_data')});
			}
			
			return update(state, {
				searchResult: { $set: result }
			});
		case MANAGE_GET_AGENT_SUCCESS:
			// 若有帶agentId，則為取得子帳號agentInfo
			if (action.agentId) {
				let initAgentInfo = JSON.parse(JSON.stringify(action.data));

				// 整理title格式
				// if (initAgentInfo.title === 'MR') initAgentInfo.title = 'Mr.';
				// if (initAgentInfo.title === 'MS') initAgentInfo.title = 'Ms.';

				initAgentInfo.confirmEmail = initAgentInfo.email;

				// 若addressState為空，則塞入預設值
				if (!initAgentInfo.addressState) initAgentInfo.addressState = 'OTH';

				// 若無mobilePhone資料則塞入空字串
				if (!initAgentInfo.mobilePhone) {
					initAgentInfo.mobilePhone = {
						id: null,
						number: '',
						dialCode: ''
					};
				}
				// 若無workPhone資料則塞入空字串
				if (!initAgentInfo.workPhone) {
					initAgentInfo.workPhone = {
						id: null,
						number: '',
						dialCode: ''
					};
				}

				return update(state, {
					agentInfo: { $set: initAgentInfo }
				});
			} else { // 未帶agentId，則為取得註冊帳號agentInfo
				let initAddressInfo = {};

				if (action.data) {
					initAddressInfo = {
						address1: action.data.address1,
						address2: action.data.address2,
						city: action.data.city,
						addressState: action.data.addressState || 'OTH',
						country: action.data.country,
						postalCode: action.data.postalCode
					};
				}
				
				return update(state, {
					addressInfo: { $set: initAddressInfo }
				});
			}
			
		case MANAGE_PUT_AGENT_SUCCESS:
			return update(state, {
				showSuccessDialog: { $set: true }
			});
		case MANAGE_UPDATE_AGENT_INFO:
			return update(state, {
				agentInfo: { $set: action.data }
			});
		case MANAGE_CLEAR_AGENT_INFO:
			return update(state, {
				agentInfo: { $set: initState.agentInfo },
        errors: { $set: initState.errors },
				showSuccessDialog: { $set: initState.showSuccessDialog }
			});
		case MANAGE_CLEAR_AGENT_LIST:
			return update(state, {
				searchResult: { $set: initState.searchResult },
      });
		case MANAGE_POST_ERROR:
      return update(state, {
        errors: { $set: action.errors }
      });
    case MANAGE_CLEAR_ERROR:
      return update(state, {
        errors: { $set: initState.errors }
      });
		default:
			return state;
	}
}